import { forwardRef, useImperativeHandle } from 'react';
import { createZodFormResolver, useFormControls } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { useCityLedgerMultipleInvoicesContext } from '../../context/CityLedgerMultipleInvoicesContext';
import { InvoiceSelect } from './InvoiceSelect';
import { PayerAccountSelect } from './PayerAccountSelect';
import {
    TwoStepProcessPaymentFormField,
    TwoStepProcessPaymentFormModel,
    TwoStepProcessPaymentInvoiceIdsSchema,
} from './payerInformationschema';

export interface PayerInformationConfigurationFormRef {
    submit: () => void;
    hasDirtyFields: boolean;
}

interface TwoStepProcessPayerInformationProps {
    onSubmit: (payerInfoParameters: TwoStepProcessPaymentFormModel) => void;
}

export const TwoStepProcessPayerInformation = forwardRef<
    PayerInformationConfigurationFormRef,
    TwoStepProcessPayerInformationProps
>(({ onSubmit }, ref) => {
    const { invoiceIds } = useCityLedgerMultipleInvoicesContext();

    const { renderFormContent, submit, hasDirtyFields } = useFormControls<TwoStepProcessPaymentFormModel>({
        id: 'city-ledger-two-step-process-payment',
        defaultValues: {
            invoiceIds,
        },
        resolver: createZodFormResolver(TwoStepProcessPaymentInvoiceIdsSchema),
        mode: 'onChange',
        onSubmit,
    });

    useImperativeHandle(ref, () => ({
        submit,
        hasDirtyFields,
    }));

    return renderFormContent(
        <Stack vertical spacing="200">
            <InvoiceSelect data-test-id="invoice-select" name={TwoStepProcessPaymentFormField.invoiceIds} />
            <PayerAccountSelect name={TwoStepProcessPaymentFormField.payerAccountId} />
        </Stack>
    );
});
